import { useState } from 'react';
import { VerificationStepsItem } from 'src/store-redux/siteUpload/siteUploadStore.types';

export const useSiteUploadDrawerHooks = () => {
  const [additionalComment, setAdditionalComment] = useState<string>();
  const [askQuit, setAskQuit] = useState<boolean>(false);
  const [dirtyDrawerState, setDirtyDrawerState] = useState<boolean>(false);
  const [verificationStepsData, setVerificationStepsData] = useState<
    Partial<VerificationStepsItem>[] | undefined
  >();
  const [currentStep, setCurrentStep] = useState(0);
  const [file, setFile] = useState<File | null>();
  const [visitName, setVisitName] = useState<string | null>();
  const [disableConfirmUpload, setDisableConfirmUpload] = useState(true);
  const [siteCode, setSiteCode] = useState<string | undefined>('');
  const [reuploadDrawer, setReuploadDrawer] = useState<boolean>(false);

  return {
    additionalComment,
    askQuit,
    dirtyDrawerState,
    verificationStepsData,
    currentStep,
    file,
    visitName,
    disableConfirmUpload,
    siteCode,
    reuploadDrawer,

    setAdditionalComment,
    setAskQuit,
    setDirtyDrawerState,
    setVerificationStepsData,
    setCurrentStep,
    setFile,
    setVisitName,
    setDisableConfirmUpload,
    setSiteCode,
    setReuploadDrawer,
  };
};
